<template>
    <div class=text-popup :class="{ 'is-active' : isActive }">

        <div class=popup-content>

            <div class=text v-html="content"></div>

            <ContentBlocks v-if="blocks" :blocks="blocks" @button-click="$emit('button-click')" />

        </div>

        <div class=close @click="$emit('close-popup')"></div>

    </div>
</template>
<script>

import ContentBlocks from './ContentBlocks.vue';

export default {
    name : 'RichTextPopup',
    props : {
        content  : String  ,
        blocks   : Array   ,
        isActive : Boolean ,
    },
    components : {
        ContentBlocks,
    }
}
</script>